import React, { memo } from 'react';
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, IconButton, Icon, Tooltip, Stack, Typography } from 'investira.react.components';
import { validators, formats } from 'investira.sdk';
import ConcentracaoGraph from './ConcentracaoGraph';
import { useConsultaContext } from '../../../../../contexts/ConsultaContext';
const ConcentracaoTable = memo(props => {
  const {
    detalhe,
    onSetRegra
  } = props;
  const {
    state
  } = useConsultaContext();
  function calcRangeEnquadramento(pMin = 0, pMax = 50) {
    return Math.abs(pMax - pMin);
  }
  function calcAlvoRange(pAlvo = null, pAlvoLimites = {}, pDesenquadradoAlvo = null, pDesenquadrado = null) {
    let targetColors = 'white';
    if (!validators.isNull(pDesenquadrado)) {
      targetColors = 'error.light';
    }
    if (!validators.isNull(pDesenquadradoAlvo)) {
      targetColors = 'warning.light';
    }
    return {
      alvo: pAlvo,
      alvoLimites: pAlvoLimites,
      alvoWidth: pAlvoLimites?.maximo - pAlvoLimites.minimo,
      desenquadradoAlvo: !validators.isNull(pDesenquadradoAlvo),
      pDesenquadrado: !validators.isNull(pDesenquadrado),
      noAlvo: !validators.isNull(pDesenquadradoAlvo),
      targetColor: targetColors
    };
  }
  function calcObservado(pObservado) {
    if (pObservado <= 0) {
      return '0%';
    }
    return `calc(${pObservado}% - 1px)`;
  }
  const detalheFiltrado = state.exibir_desenquadrado ? detalhe.filter(x => x.desenquadrado) : detalhe;
  return <TableContainer id="table-container" sx={{
    overflow: 'auto'
  }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Descrição</TableCell>
            <TableCell></TableCell>
            <TableCell align="right">Mínimo (%)</TableCell>
            <TableCell align="right">Máximo (%)</TableCell>
            <TableCell align="right">Observado</TableCell>
            <TableCell align="right">Observado (%)</TableCell>
            <TableCell align="right">Desenquadrado</TableCell>
            <TableCell align="right">Alvo (%)</TableCell>
            <TableCell align="right" sx={{
            whiteSpace: 'nowrap',
            lineHeight: 1,
            position: 'relative'
          }}>
              <span>Desenquadrado (Alvo)</span>
              <Tooltip title={<React.Fragment>
                    <Typography color="inherit" variant="caption" component="p" gutterBottom>
                      <b>Desenquadrado (Alvo)</b>
                    </Typography>
                    <Typography color="inherit" variant="caption" component="p" gutterBottom>
                      Métrica de Desenquadramento Relacionado ao Alvo:
                    </Typography>
                    <Typography color="inherit" variant="caption" component="p" gutterBottom>
                      Esta métrica avalia o desempenho com base na proximidade em relação a um valor
                      alvo estabelecido.
                    </Typography>
                    <Typography color="inherit" variant="caption" component="p" gutterBottom>
                      Para um alvo definido de 5%, a faixa de tolerância para se considerar
                      enquadrado permite uma variação de ±5% em relação a este alvo, criando uma
                      margem de tolerância total de 10%.
                    </Typography>
                    <Typography color="inherit" variant="caption" component="p" gutterBottom>
                      Consequentemente, a zona aceitável para enquadramento nesta métrica situa-se
                      entre 0% e 10%, sendo a faixa ideal (o alvo propriamente dito) entre 4,5% e
                      5,5%.
                    </Typography>
                  </React.Fragment>}>
                <span style={{
                position: 'absolute',
                right: -10,
                top: '50%',
                transform: 'translateY(-50%)'
              }}>
                  <Icon size={16} color={'primary'} iconName="information" />
                </span>
              </Tooltip>
            </TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {detalheFiltrado.map(xDetalhe => {
          const hasDesenquadrado = !validators.isNull(xDetalhe.desenquadrado);
          const hasDesenquadradoAlvo = !validators.isNull(xDetalhe.desenquadrado_alvo);
          const xEnquadramentoRange = calcRangeEnquadramento(xDetalhe.minimo, xDetalhe.maximo);
          const xAlvo = calcAlvoRange(xDetalhe.alvo, xDetalhe.alvo_limites, xDetalhe.desenquadrado_alvo, xDetalhe.desenquadrado);
          const xObservado = calcObservado(xDetalhe.observado);
          const isEnquadrado = validators.isNull(xDetalhe.desenquadrado);
          return <React.Fragment key={crypto.randomUUID()}>
                <TableRow>
                  <TableCell colSpan={2} sx={{
                color: xAlvo.targetColor
              }}>
                    {xDetalhe.descricao}
                  </TableCell>
                  <TableCell align="right" sx={{
                color: 'text.secondary'
              }}>
                    {xDetalhe.minimo}
                  </TableCell>
                  <TableCell align="right" sx={{
                color: 'text.secondary'
              }}>
                    {xDetalhe.maximo}
                  </TableCell>
                  <TableCell align="right" sx={{
                color: xAlvo.targetColor
              }}>
                    {formats.formatNumber(xDetalhe.financeiro, 2, true)}
                  </TableCell>
                  <TableCell align="right" sx={{
                color: xAlvo.targetColor
              }}>
                    {xDetalhe.observado && formats.formatNumber(xDetalhe.observado, 6, true)}
                  </TableCell>
                  <TableCell align={hasDesenquadrado ? 'right' : 'center'} sx={{
                color: xAlvo.targetColor
              }}>
                    <Stack gap={1} direction="row" alignItems="center" justifyContent="flex-end">
                      {hasDesenquadrado ? formats.formatNumber(xDetalhe.desenquadrado, 2, true) : ''}
                    </Stack>
                  </TableCell>
                  <TableCell align="right" sx={{
                color: 'info.main',
                fontWeight: 600
              }}>
                    {xDetalhe.alvo && formats.formatNumber(xDetalhe.alvo)}
                  </TableCell>
                  <TableCell align={hasDesenquadradoAlvo ? 'right' : 'center'} sx={{
                color: xAlvo.targetColor
              }}>
                    <Stack gap={1} direction="row" alignItems="center" justifyContent="flex-end">
                      {xDetalhe.desenquadrado_alvo && <Tooltip title={'Fora do alvo definido'} arrow>
                          <IconButton color="warning" size="small">
                            <Icon iconName="target" size={16} />
                          </IconButton>
                        </Tooltip>}
                      {hasDesenquadradoAlvo ? formats.formatNumber(xDetalhe.desenquadrado_alvo, 2, true) : ''}
                    </Stack>
                  </TableCell>
                  <TableCell align="center">
                    <ConcentracaoGraph range={xEnquadramentoRange} minimo={xDetalhe.minimo} alvo={xAlvo} observado={xObservado} targetColor={xAlvo.targetColor} />
                  </TableCell>
                  <TableCell align="center">
                    <IconButton color="primary" size="small" onClick={() => onSetRegra({
                  ...xDetalhe,
                  grafico: {
                    range: xEnquadramentoRange,
                    minimo: xDetalhe.minimo,
                    alvo: xAlvo,
                    observado: xObservado,
                    enquadrado: isEnquadrado
                  }
                })}>
                      <Icon iconName="eye" size={21} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              </React.Fragment>;
        })}
        </TableBody>
      </Table>
    </TableContainer>;
});
ConcentracaoTable.displayName = 'ConcentracaoTable';
export default ConcentracaoTable;
